import React from 'react';
import style from './flightStartEndDates.module.scss';
import { DateType } from 'acscp/api/models/customTypes/dateType';
import { Leg } from 'acscp/store';
import {FormattedDate} from '../common/formattedDate';
import {FormattedDateRange} from 'acscp/components/common/formattedDateRange';

export class FlightStartEndDates extends React.Component<{legs: Leg[]}, {}> {
    render(): JSX.Element|null {
        const firstLeg = this.props.legs[0];
        const lastLeg = this.props.legs[this.props.legs.length - 1];
        const allLegsHaveExactDate = this.props.legs.every(l => l.departureDateType === DateType.EXACT);
        return (
            <div className={style.Dates}>
                <span className={style.Date}>
                    <FormattedDateRange date={firstLeg.departureDate} rangeEndDate={firstLeg.departureRangeEndDate}/>
                </span>
                {allLegsHaveExactDate && (
                    <span className={style.Date}>
                        <FormattedDate date={lastLeg.arrivalDate} />
                    </span>
                )}
            </div>
        );
    }
}
